import { useState, useEffect } from "react";
import "./CardAddToCar.css";

export default function CardAddToCar({
    produto,
    preco,
    limitecrdt,
}) {
    const saldo = Number(produto.saldototal) || 0;
    //console.log("limite",limitecrdt)
    const [quantidade, setQuantidade] =
        useState(1);


    const [mensagem, setMensagem] = useState("");
    const [tipoMensagem, setTipoMensagem] = useState("erro");

    const multiplicador =
        produto.ehCaixa
            ? produto.pesoCaixa
            : produto.ehPesoPorPeca
                ? produto.pesoPeca
                : 1;

    const valorTotal =
        quantidade *
        multiplicador *
        preco;


    function validarQuantidade(valor) {
        let qtd = Number(valor);

        if (isNaN(qtd) || qtd < 1) {
            qtd = 1;
        }

        if (qtd > saldo) {
            setTipoMensagem("erro");
            setMensagem("Saldo insuficiente.");
            qtd = saldo;
        } else {
            setMensagem("");
        }

        setQuantidade(qtd);
    }

    function diminuir() {
        if (quantidade > 1) {
            setQuantidade(quantidade - 1);
            setMensagem("");
        }
    }

    function aumentar() {
        if (quantidade < saldo) {
            setQuantidade(quantidade + 1);
            setMensagem("");
        } else {
            setTipoMensagem("erro");
            setMensagem("Saldo insuficiente.");
        }
    }

    function adicionarCarrinho() {
        const cart =
            JSON.parse(
                localStorage.getItem("carrinho")
            ) || [];

        const existe = cart.some(
            (item) =>
                item.codProduto ===
                String(produto.CodItem)
        );

        if (existe) {
            setTipoMensagem("erro");
            setMensagem(
                "Produto já adicionado ao carrinho."
            );
            return;
        }

        const totalCarrinho = Number(
            cart
                .reduce(
                    (total, item) =>
                        total +
                        Number(item.quantidade) *
                        Number(item.precoUnitario),
                    0
                )
                .toFixed(2)
        );

        const valorNovoItem = Number(
            (
                Number(quantidade) *
                Number(preco)
            ).toFixed(2)
        );

        const totalPedido = Number(
            (
                totalCarrinho +
                valorNovoItem
            ).toFixed(2)
        );

        const limite = Number(limitecrdt ?? 0);
        //Comentado bloqueio de limite de crédito excedito com produtos do carrinho
        /*
            if (totalPedido > limite) {
                setTipoMensagem("erro");
                setMensagem(
                    "O valor do pedido excede o limite de crédito disponível."
                );
                return;
            }
                
        */
        const cartItem = {
            nome: produto.Descricao,
            codProduto: String(produto.CodItem),

            quantidade,

            precoUnitario: Number(preco),

            pesob: Number(produto.pesob),
            pesol: Number(produto.pesol),

            ehCaixa: Boolean(produto.ehCaixa),
            pesoCaixa: Number(produto.pesoCaixa ?? 0),

            ehPesoPorPeca: Boolean(produto.ehPesoPorPeca),
            pesoPeca: Number(produto.pesoPeca ?? 0),
        };

        cart.push(cartItem);

        console.log(cartItem);

        localStorage.setItem(
            "carrinho",
            JSON.stringify(cart)
        );

        window.dispatchEvent(
            new Event("carrinhoAtualizado")
        );

        setTipoMensagem("sucesso");
        setMensagem(
            "Produto adicionado ao carrinho."
        );
    }

    useEffect(() => {
        if (!mensagem) return;

        const timer = setTimeout(() => {
            setMensagem("");
        }, 3000);

        return () => clearTimeout(timer);
    }, [mensagem]);

    return (
    <div className="cardAddCart-container">

        <div className="cardAddCart-acoes">

            <div className="cardAddCart-quantidadeBox">

                <button
                    onClick={diminuir}
                    disabled={saldo <= 0}
                >
                    -
                </button>

                <input
                    type="number"
                    min={1}
                    max={saldo}
                    value={quantidade}
                    disabled={saldo <= 0}
                    onChange={(e) =>
                        validarQuantidade(e.target.value)
                    }
                />

                <button
                    onClick={aumentar}
                    disabled={saldo <= 0}
                >
                    +
                </button>

            </div>

            <button
                className="cardAddCart-botao"
                disabled={saldo <= 0}
                onClick={adicionarCarrinho}
            >
                Adicionar ao carrinho
            </button>

        </div>

        <div className="cardAddCart-valorTotal">

            <div className="cardAddCart-valorLinha">

                <span>Valor Total:</span>

                <strong>
                    R$ {valorTotal.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}
                </strong>

            </div>

            {produto.ehCaixa && (

                <div className="cardAddCart-valorInfo">

                    {quantidade} {quantidade === 1 ? "caixa" : "caixas"}
                    {" × "}
                    {produto.pesoCaixa} kg
                    {" × "}
                    R$ {preco.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}
                    /kg

                </div>

            )}

            {produto.ehPesoPorPeca && (

                <div className="cardAddCart-valorInfo">

                    {quantidade} {quantidade === 1 ? "peça" : "peças"}
                    {" × "}
                    {produto.pesoPeca} kg
                    {" × "}
                    R$ {preco.toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}
                    /kg

                </div>

            )}

        </div>

        <div
            className={`cardAddCart-mensagem ${
                saldo <= 0
                    ? "cardAddCart-erro"
                    : tipoMensagem === "erro"
                    ? "cardAddCart-erro"
                    : "cardAddCart-sucesso"
            }`}
        >
            {saldo <= 0
                ? "Produto indisponível."
                : mensagem}
        </div>

    </div>
);
}